export const recruiterConstants = {
  CREATE_RECRUITER: "CREATE_RECRUITER",
  UPDATE_RECRUITER: "UPDATE_RECRUITER",
  GET_RECRUITERS: "GET_RECRUITERS",
  GET_RECRUITER_BY_ID: "GET_RECRUITER_BY_ID",
  DELETE_RECRUITER: "DELETE_RECRUITER",
  GET_RECRUITER_LIST: "GET_RECRUITER_LIST",
  GET_RECRUITER_ASSIGNED_PROJECTS: "GET_RECRUITER_ASSIGNED_PROJECTS",
  IS_MANAGER: "IS_MANAGER",
  MANAGER : 2,
  RECRUITER: 3,
  CANDIDATE: 4
};
